import { TipoDespesaDTO } from 'app/main/a2w/supervisor/cadastros/relatorio-despesas/tipos-despesas/models/tipo-despesa.model';
import { TipoPagamentoDTO } from 'app/main/a2w/supervisor/cadastros/relatorio-despesas/tipos-pagamentos/models/tipo-pagamento.model';

export class LancamentoDespesaViagemDTO {
    id: number;
    guidId: any;
    accountId: any;
    userId: any;
    relatorioDespesaViagemId: number;
    tipoDespesaViagemId: number;
    tipoDespesa: TipoDespesaDTO;
    tipoPagtoDespesaViagemId: number;
    tipoPagto: TipoPagamentoDTO;
    dataDespesa: any;
    valorDespesa: any;
    observacoesDespesa: string;
    statusLancamento: any;
    nomeArquivoComprovante: string;
    caminhoArquivoComprovante: string;
    km: number;
    kmFinal: number;
    kmInicial: number;
    status: number;
    reembolsavel: boolean;
    reembolsarAcimaLimite: boolean;
    valorRegraLimite: number;
    diminuirSaldo: boolean;
    nomeArquivoComprovante2: string;
    caminhoArquivoComprovante2: string;
    nomeComprovantePDF: string;
    caminhoComprovantePDF: string;
    motivoRejeicao: string;
    diarias: number;
    projetoId: number;
    tagsProibidas: string;
    valorReembolsavel: number;
    estabelecimento: string;


    imagemAtual: number;
  
    constructor(lancamentoDespesaViagem?) {
      lancamentoDespesaViagem = lancamentoDespesaViagem || {};
      
      this.id = lancamentoDespesaViagem.id || 0;
      this.guidId = lancamentoDespesaViagem.guidId || null;
      this.accountId = lancamentoDespesaViagem.accountId || null;
      this.userId = lancamentoDespesaViagem.userId || null;
      this.relatorioDespesaViagemId = lancamentoDespesaViagem.relatorioDespesaViagemId || 0;
      this.tipoDespesaViagemId = lancamentoDespesaViagem.tipoDespesaViagemId || 0;
      this.tipoDespesa = lancamentoDespesaViagem.tipoDespesa || null;
      this.tipoPagtoDespesaViagemId = lancamentoDespesaViagem.tipoPagtoDespesaViagemId || 0;
      this.tipoPagto = lancamentoDespesaViagem.tipoPagto || null;
      this.dataDespesa = lancamentoDespesaViagem.dataDespesa || null;
      this.valorDespesa = lancamentoDespesaViagem.valorDespesa || 0;
      this.observacoesDespesa = lancamentoDespesaViagem.observacoesDespesa || '';
      this.statusLancamento = lancamentoDespesaViagem.statusLancamento || 0;
      this.nomeArquivoComprovante = lancamentoDespesaViagem.nomeArquivoComprovante || '';
      this.caminhoArquivoComprovante = lancamentoDespesaViagem.caminhoArquivoComprovante || '';
      this.km = lancamentoDespesaViagem.km || 0;
      this.status = lancamentoDespesaViagem.status || 0;
      this.reembolsavel = lancamentoDespesaViagem.reembolsavel || false;
      this.reembolsarAcimaLimite = lancamentoDespesaViagem.reembolsarAcimaLimite || false;
      this.valorRegraLimite = lancamentoDespesaViagem.valorRegraLimite || 0;
      this.diminuirSaldo = lancamentoDespesaViagem.diminuirSaldo || false;
      this.nomeArquivoComprovante2 = lancamentoDespesaViagem.nomeArquivoComprovante2 || '';
      this.caminhoArquivoComprovante2 = lancamentoDespesaViagem.caminhoArquivoComprovante2 || '';
      this.nomeComprovantePDF = lancamentoDespesaViagem.nomeComprovantePDF || '';
      this.caminhoComprovantePDF = lancamentoDespesaViagem.caminhoComprovantePDF || '';
      this.motivoRejeicao = lancamentoDespesaViagem.motivoRejeicao || '';
      this.diarias = lancamentoDespesaViagem.diarias || 0;
      this.projetoId = lancamentoDespesaViagem.projetoId || 0;
      this.tagsProibidas = lancamentoDespesaViagem.tagsProibidas || '';
      this.valorReembolsavel = lancamentoDespesaViagem.valorReembolsavel || 0;
      this.estabelecimento = lancamentoDespesaViagem.estabelecimento || '';

      this.imagemAtual = 0;
    }
}
